<template>
	<div class="my-4 flex flex-col items-center justify-center space-y-2">
		<div
			v-if="blok.has_background"
			:id="blok._uid"
			:class="{
				'relative flex size-20 items-center justify-between rounded-full bg-gray-100':
					blok.has_background,
			}"
		>
			<v-icon
				v-if="iconName"
				class="absolute top-1/2 left-1/2 -translate-1/2 fill-black text-center text-8xl"
				:icon="iconName"
			/>

			<nuxt-picture
				v-else-if="iconImage?.filename"
				:key="iconImage.filename"
				:src="iconImage.filename"
				provider="storyblok"
				loading="lazy"
				height="80"
				width="80"
				class="absolute top-1/2 left-1/2 -translate-1/2"
			/>
		</div>

		<v-icon
			v-if="!blok.has_background && iconName"
			class="relative fill-red-500 text-center text-11xl"
			:icon="iconName"
		/>

		<nuxt-picture
			v-else-if="!blok.has_background && iconImage?.filename"
			:key="iconImage.filename"
			:src="iconImage.filename"
			provider="storyblok"
			loading="lazy"
			height="96"
			width="96"
			class="relative text-center text-11xl"
		/>

		<div :class="{'my-md': blok.has_background}">
			<p class="text-center font-sans-caption text-base font-bold">
				{{ blok.title }}
			</p>
		</div>

		<p class="text-center font-sans text-base">{{ blok.content }}</p>

		<nuxt-link v-if="blok.button_text" :to="url" :aria-label="blok.button_text">
			<v-button theme="black" size="base" class="my-auto mt-md inline-block">
				{{ blok.button_text }}
			</v-button>
		</nuxt-link>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

import formatSbUrl from "@pkg/shared/utils/format-sb-url";

const properties = defineProps<{
	blok: Extract<
		BlokComponent,
		{component: "sb-text-columns" | "sb-text-column"}
	>;
}>();

const iconName = computed(() => properties.blok.icon);
const iconImage = computed(() => properties.blok.icon_image);

const url = computed(() => formatSbUrl(properties.blok.button_link));
</script>
